import Footer from "./components/Footer/Footer";
import Header from "./components/Header/Header";
import styles from "./App.module.scss";
import { Suspense, useContext } from "react";
import { Outlet, useLocation } from "react-router-dom";
import ThemeContext from "context/ThemeContext";
import { ThemeContextType } from "types";

function App() {
  const { color } = useContext(ThemeContext) as ThemeContextType;
  const location = useLocation();
  const isPokemonProfilePage = location.pathname.startsWith("/pokemon");

  // #001220
  // #e4e3e3
  const backgroundSVG = `
  <svg
      id="visual"
      viewBox="0 0 1920 1080"
      width="1920"
      height="1080"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
    >
      <rect x="0" y="0" width="1920" height="1080" fill="#041823"></rect>
      <defs>
        <linearGradient id="grad1_0" x1="43.8%" y1="0%" x2="100%" y2="100%">
          <stop
            offset="14.444444444444446%"
            stop-color="#041823"
            stop-opacity="1"
          ></stop>
          <stop
            offset="85.55555555555554%"
            stop-color="#041823"
            stop-opacity="1"
          ></stop>
        </linearGradient>
      </defs>
      <defs>
        <linearGradient id="grad2_0" x1="0%" y1="0%" x2="56.3%" y2="100%">
          <stop
            offset="14.444444444444446%"
            stop-color="#041823"
            stop-opacity="1"
          ></stop>
          <stop
            offset="85.55555555555554%"
            stop-color="#041823"
            stop-opacity="1"
          ></stop>
        </linearGradient>
      </defs>
      <g transform="translate(1920, 0)">
        <path
          d="M0 864C-61.3 799.3 -122.7 734.7 -190.5 710.9C-258.3 687.2 -332.7 704.3 -400.5 693.7C-468.3 683.1 -529.7 644.7 -601 601C-672.4 557.4 -753.8 508.3 -748.2 432C-742.7 355.7 -650.1 252 -654.9 175.5C-659.7 98.9 -761.8 49.5 -864 0L0 0Z"
          fill="${color}"
        ></path>
      </g>
      <g transform="translate(0, 1080)">
        <path
          d="M0 -864C63.9 -818.2 127.8 -772.4 204.5 -763.1C281.1 -753.8 370.4 -781.1 432 -748.2C493.6 -715.4 527.4 -622.4 538.8 -538.8C550.2 -455.2 539.2 -380.9 569 -328.5C598.8 -276.1 669.4 -245.5 725.4 -194.4C781.4 -143.3 822.7 -71.6 864 0L0 0Z"
          fill="${color}"
        ></path>
      </g>
  </svg>
`;

  return isPokemonProfilePage ? (
    <div
      className={`d-flex flex-column ${styles.appContainer}`}
      style={{
        backgroundImage: `url("data:image/svg+xml,${encodeURIComponent(
          backgroundSVG
        )}")`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed",
      }}
    >
      <Header />
      <Suspense>
        <Outlet />
      </Suspense>
      <Footer />
    </div>
  ) : (
    <div className={`d-flex flex-column ${styles.appContainer}`}>
      <Header />
      <Suspense>
        <Outlet />
      </Suspense>
      <Footer />
    </div>
  );
}

export default App;
